export default {
    permissions: 'دسترسی ها',
    permissionGroup: 'گروه دسترسی ',
    permissionGroups: 'گروهٰ‌های دسترسی',
    permission: 'دسترسی ',
    createPermissionsGroup: 'ایجاد گروه دسترسی‌ها',
    permissionsList: 'لیست دسترسی‌ها',
    createGroup: 'ایجاد گروه',
    title: 'عنوان دسترسی',
    groupTitle: 'عنوان گروه دسترسی',
    parent: 'سردسته',
    key: 'شناسه',
    unit: 'واحد‌',
    room: 'اتاق‌',
    permissionGroupTitle: 'عنوان گروه',
    unitPermissions: 'دسترسی واحدها',
    roomPermissions: 'دسترسی اتاق‌ها',
}